let serverTimeOffset = 0;

/**
 * Sets the time offset based on the server's time.
 * This should be called periodically to keep the client's time synchronized.
 * @param serverNow - The current timestamp from the server (in milliseconds or as a date string).
 */
export function setServerTimeOffset(serverNow: number | string) {
  serverTimeOffset = new Date(serverNow).getTime() - Date.now();
}

/**
 * Gets the current time, adjusted by the server offset.
 * @returns The synchronized current time in milliseconds since the epoch.
 */
export function now(): number {
  return Date.now() + serverTimeOffset;
}
